var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ui-chip tw-inline-block tw-text-white rounded tw-px-2 tw-font-medium tw-truncate",class:{
    'tw-bg-yellow-500': _vm.color === 'yellow',
    'tw-bg-teal-500': _vm.color === 'teal',
    'tw-bg-blue-500': _vm.color === 'blue',
    'tw-bg-purple-500': _vm.color === 'purple'
  }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }